export default [
	{
		path: "/",
		name: "admin.dashboard",
		component: () => import("@/resources/admin/dashboard"),
	},
	{
		path: "user",
		name: "admin.user",
		component: () => import("@/resources/admin/user"),
		redirect: {
			name: "admin.user.list",
		},
		children: [
			{
				path: "list",
				name: "admin.user.list",
				component: () => import("@/resources/admin/user/list"),
			},
			{
				path: "edit/:id",
				name: "admin.user.edit",
				component: () => import("@/resources/admin/user/edit"),
			},
			{
				path: "create",
				name: "admin.user.create",
				component: () => import("@/resources/admin/user/create"),
			},
		],
	},
	{
		path: "staff",
		name: "admin.staff",
		component: () => import("@/resources/admin/staff"),
		redirect: {
			name: "admin.staff.list",
		},
		children: [
			{
				path: "list",
				name: "admin.staff.list",
				component: () => import("@/resources/admin/staff/list"),
			},
			{
				path: "edit/:id",
				name: "admin.staff.edit",
				component: () => import("@/resources/admin/staff/edit"),
			},
			{
				path: "create",
				name: "admin.staff.create",
				component: () => import("@/resources/admin/staff/create"),
			},
		],
	},
	{
		path: "course",
		name: "admin.course",
		component: () => import("@/resources/admin/course"),
		redirect: {
			name: "admin.course.list",
		},
		children: [
			{
				path: "list",
				name: "admin.course.list",
				component: () => import("@/resources/admin/course/list"),
			},
			{
				path: "edit/:id",
				name: "admin.course.edit",
				component: () => import("@/resources/admin/course/edit"),
			},
			{
				path: "create",
				name: "admin.course.create",
				component: () => import("@/resources/admin/course/create"),
			},
			{
				path: "detail/:id",
				name: "admin.course.detail",
				component: () => import("@/resources/admin/course/detail"),
			},
		],
	},
	{
		path: "news",
		name: "admin.news",
		component: () => import("@/resources/admin/news"),
		redirect: {
			name: "admin.news.list",
		},
		children: [
			{
				path: "list",
				name: "admin.news.list",
				component: () => import("@/resources/admin/news/list"),
			},
			{
				path: "edit/:id",
				name: "admin.news.edit",
				component: () => import("@/resources/admin/news/edit"),
			},
			{
				path: "create",
				name: "admin.news.create",
				component: () => import("@/resources/admin/news/create"),
			},
			{
				path: "detail/:id",
				name: "admin.news.detail",
				component: () => import("@/resources/admin/news/detail"),
			},
		],
	},
	{
		path: "recruitment",
		name: "admin.recruitment",
		component: () => import("@/resources/admin/recruitment"),
		redirect: {
			name: "admin.recruitment.list",
		},
		children: [
			{
				path: "list",
				name: "admin.recruitment.list",
				component: () => import("@/resources/admin/recruitment/list"),
			},
			{
				path: "edit/:id",
				name: "admin.recruitment.edit",
				component: () => import("@/resources/admin/recruitment/edit"),
			},
			{
				path: "create",
				name: "admin.recruitment.create",
				component: () => import("@/resources/admin/recruitment/create"),
			},
		],
	},
	{
		path: "cooperation",
		name: "admin.cooperation",
		component: () => import("@/resources/admin/cooperation"),
		redirect: {
			name: "admin.cooperation.list",
		},
		children: [
			{
				path: "list",
				name: "admin.cooperation.list",
				component: () => import("@/resources/admin/cooperation/list"),
			},
			{
				path: "edit/:id",
				name: "admin.cooperation.edit",
				component: () => import("@/resources/admin/cooperation/edit"),
			},
			{
				path: "create",
				name: "admin.cooperation.create",
				component: () => import("@/resources/admin/cooperation/create"),
			},
		],
	},
	{
		path: "manage-web",
		name: "admin.manage-web",
		component: () => import("@/resources/admin/manage"),
		children: [
			{
				path: "manage-home",
				name: "admin.manage-web.manage-home",
				component: () => import("@/resources/admin/manage/manageHome"),
			},
			{
				path: "manage-about",
				name: "admin.manage-web.manage-about",
				component: () => import("@/resources/admin/manage/manageAbout"),
			},
			{
				path: "manage-training",
				name: "admin.manage-web.manage-training",
				component: () => import("@/resources/admin/manage/manageTraining"),
			},
			{
				path: "manage-recruitment",
				name: "admin.manage-web.manage-recruitment",
				component: () => import("@/resources/admin/manage/manageRecruitment"),
			},
			{
				path: "manage-config",
				name: "admin.manage-web.manage-config",
				component: () => import("@/resources/admin/manage/manageConfig"),
			},
		],
	},
	{
		path: "manage-upload",
		name: "admin.manage-upload",
		component: () => import("@/resources/admin/manage-upload"),
	},
];
